/**
 * F66 reader-mode theme axis — light/sepia/dark/high-contrast — a SEPARATE
 * axis from the app light/dark theme (`users.theme`, `ThemeProvider`) and
 * the F65 document Theme (`documentThemes.ts`); never conflated
 * (CODE_GUIDELINES §4/§28.3). Purely a local reading preference: no server
 * schema/op owns it (only `reader.position` is server-synced), so it's
 * persisted client-side only (`useReaderPrefs.ts`).
 */
export const READER_THEME_IDS = ['light', 'sepia', 'dark', 'highContrast'] as const;
export type ReaderThemeId = (typeof READER_THEME_IDS)[number];

export interface ReaderThemePalette {
  background: string;
  text: string;
}

/** Colors mirror design/app/30-reader.html's `readerBg`/`readerText` map. */
export const READER_THEME_PALETTE: Record<ReaderThemeId, ReaderThemePalette> = {
  light: { background: '#fbf4e9', text: '#2b2620' },
  sepia: { background: '#f1e4cc', text: '#4a3a22' },
  dark: { background: '#1c1a18', text: '#e8e2d8' },
  highContrast: { background: '#000000', text: '#ffffff' },
};

export const READER_FONT_SCALE_STEPS = [0.875, 1, 1.125, 1.25, 1.4] as const;
export const READER_DEFAULT_FONT_SCALE_INDEX = 1;

export const READER_LAYOUT_MODES = ['scroll', 'paginated'] as const;
export type ReaderLayoutMode = (typeof READER_LAYOUT_MODES)[number];
